/**
 * @Author: Zero
 * @Date: 2024-09-11 09:53:58
 * @Explain: 分组报表
 */

import http from '../http';

const MODEL = '/campaign_group_report';

export default {
  /** 分组报表 - 列表 */
  getList(data: Record<any, any>) {
    return http.post(`${MODEL}/list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 更新数据 */
  onUpdateData(data: Record<any, any>) {
    return http.post(`${MODEL}/update_data`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 添加 */
  onAdd(data: Record<any, any>) {
    return http.post(`${MODEL}/create`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 编辑 */
  onEdit(data: Record<any, any>) {
    return http.post(`${MODEL}/edit`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 查重名 */
  checkName(data: Record<any, any>) {
    return http.post(`${MODEL}/check_name`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 删除 */
  onDel(data: Record<any, any>) {
    return http.post(`${MODEL}/delete`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 获取活动列表 */
  getActivityList(data: Record<any, any>) {
    return http.post(`${MODEL}/task_list`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 按分组uuid拉列表 */
  getListByUuid(data: Record<any, any>) {
    return http.post(`${MODEL}/list_by_uuid`, data, {
      params: { switchReqToUnderline: true },
    });
  },
  /** 分组报表 - 报表详情 - 送达能力 & 邮件参与  */
  getDeliveryAndEmailDetails(data: Record<any, any>) {
    return http.post(`${MODEL}/detail`, data, {
      params: { switchReqToUnderline: true },
    });
  },
};
